/**
 * Overwritten by scripts/inject-posthog-env.js in CI.
 */
export const POSTHOG_KEY = "phc_vKy8iTTdxfqWZ4mLNRGLs9WUYk36b8saza9eZKceczMr"
export const POSTHOG_HOST = "https://eu.i.posthog.com"
